let showNotification = () => {};

export const registerNotificationHandler = (handler) => {
  showNotification = handler;
  //console.log("registerNotificationHandler")
};

export const notification = (message, type = "info", duration = 3000) => {
  showNotification({ message, type, duration });
  //console.log("notification function")
};